import React from "react";
import { motion } from "framer-motion";
import MarketingNav from "@/components/MarketingNav";
import AnnouncementBar from "@/components/AnnouncementBar";
import SiteFooter from "@/components/SiteFooter";
import { DriftingLetters, FloatingNotes, Sparkles } from "@/components/BackgroundFx";

export function AuroraBg() {
  return (
    <>
      <motion.div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{ zIndex: 0 }}
        animate={{
          background: [
            "radial-gradient(60% 50% at 20% 20%, rgba(167,116,255,0.55) 0%, transparent 60%), radial-gradient(50% 40% at 80% 30%, rgba(255,160,90,0.40) 0%, transparent 60%), radial-gradient(80% 60% at 50% 100%, rgba(80,40,180,0.55) 0%, transparent 70%)",
            "radial-gradient(55% 45% at 75% 15%, rgba(120,210,255,0.45) 0%, transparent 60%), radial-gradient(60% 50% at 15% 70%, rgba(255,120,180,0.40) 0%, transparent 60%), radial-gradient(70% 55% at 60% 100%, rgba(60,30,160,0.55) 0%, transparent 70%)",
            "radial-gradient(50% 60% at 30% 80%, rgba(120,255,200,0.40) 0%, transparent 60%), radial-gradient(60% 40% at 80% 60%, rgba(255,200,120,0.40) 0%, transparent 60%), radial-gradient(80% 60% at 40% 0%, rgba(60,30,160,0.55) 0%, transparent 70%)",
            "radial-gradient(60% 50% at 20% 20%, rgba(167,116,255,0.55) 0%, transparent 60%), radial-gradient(50% 40% at 80% 30%, rgba(255,160,90,0.40) 0%, transparent 60%), radial-gradient(80% 60% at 50% 100%, rgba(80,40,180,0.55) 0%, transparent 70%)",
          ],
        }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          zIndex: 0,
          backgroundImage:
            'url("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22240%22 height=%22240%22><filter id=%22n%22><feTurbulence baseFrequency=%220.85%22 numOctaves=%222%22 stitchTiles=%22stitch%22/></filter><rect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22/></svg>")',
        }}
      />
    </>
  );
}

/**
 * Shared shell for every marketing sub-page: aurora background, the shared top
 * nav, and the shared site footer.
 */
export default function MarketingShell({ active, children }) {
  return (
    <div
      className="relative min-h-screen w-full"
      style={{
        backgroundColor: "#080419",
        color: "#F5EFE3",
        fontFamily: "'Courier Prime', monospace",
        overflowX: "hidden",
      }}
      data-testid={`page-${active}`}
    >
      <AuroraBg />
      <DriftingLetters count={26} />
      <FloatingNotes count={7} />
      <Sparkles count={50} />
      <div className="relative" style={{ zIndex: 1 }}>
        <AnnouncementBar />
        <MarketingNav active={active} />

        <main className="max-w-[1200px] mx-auto px-6 sm:px-10 pt-14 pb-20">
          {children}
        </main>

        <SiteFooter />
      </div>
    </div>
  );
}
